import { combineReducers } from "redux";
import apiReducer from "./apiCalls";

// Combine all reducers as root reducer
export default combineReducers({
  apiReducer,
});
